/* ============================================================
   SAUNII V2 — Theme JavaScript
   Clean working version
   ============================================================ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    /* ----------------------------------------------------------
       Helpers
       ---------------------------------------------------------- */

    function lockScroll() {
      document.body.style.overflow = 'hidden';
    }

    function unlockScrollIfNothingOpen() {
      var menuOpen = document.body.classList.contains('mobile-menu-open');
      var cartOpen = document.body.classList.contains('cart-drawer-open');
      var drawerOpen = document.body.classList.contains('product-drawer-open');
      var popupOpen = document.body.classList.contains('popup-open');

      if (!menuOpen && !cartOpen && !drawerOpen && !popupOpen) {
        document.body.style.overflow = '';
      }
    }

    /* ----------------------------------------------------------
       Mobile Menu Toggle
       ---------------------------------------------------------- */

    var mobileMenu = document.getElementById('mobile-menu');

    function openMobileMenu() {
      if (!mobileMenu) return;

      mobileMenu.classList.add('active');
      mobileMenu.classList.add('open');
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');

      document.body.classList.add('mobile-menu-open');
      lockScroll();
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;

      mobileMenu.classList.remove('active');
      mobileMenu.classList.remove('open');
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('mobile-menu-open');
      unlockScrollIfNothingOpen();
    }

    document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openMobileMenu();
      });
    });

    document.querySelectorAll('[data-mobile-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileMenu();
      });
    });

    /* ----------------------------------------------------------
       Product Info Drawers — Details, Fabric & Care, Size
       ORIGINAL SIMPLE WORKING LOGIC
       ---------------------------------------------------------- */

    function closeAllProductDrawers() {
      document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
        drawer.classList.remove('open');
        drawer.classList.remove('active');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });

      document.body.classList.remove('product-drawer-open');
      document.body.classList.remove('details-drawer-open');

      unlockScrollIfNothingOpen();
    }

    document.querySelectorAll('[data-drawer-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var drawerName = this.getAttribute('data-drawer-trigger');
        var drawer = document.getElementById('drawer-' + drawerName);

        if (!drawer) {
          console.warn('[Saunii] Drawer not found:', 'drawer-' + drawerName);
          return;
        }

        document.querySelectorAll('[data-drawer]').forEach(function (otherDrawer) {
          if (otherDrawer !== drawer) {
            otherDrawer.classList.remove('open');
            otherDrawer.classList.remove('active');
            otherDrawer.classList.remove('is-open');
            otherDrawer.setAttribute('aria-hidden', 'true');
          }
        });

        drawer.classList.add('open');
        drawer.classList.add('active');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');

        document.body.classList.add('product-drawer-open');
        document.body.classList.add('details-drawer-open');

        lockScroll();
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var drawer = this.closest('[data-drawer]');

        if (drawer) {
          drawer.classList.remove('open');
          drawer.classList.remove('active');
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
        }

        if (!document.querySelector('[data-drawer].open, [data-drawer].active, [data-drawer].is-open')) {
          document.body.classList.remove('product-drawer-open');
          document.body.classList.remove('details-drawer-open');
        }

        unlockScrollIfNothingOpen();
      });
    });

    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) {
          drawer.classList.remove('open');
          drawer.classList.remove('active');
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');

          if (!document.querySelector('[data-drawer].open, [data-drawer].active, [data-drawer].is-open')) {
            document.body.classList.remove('product-drawer-open');
            document.body.classList.remove('details-drawer-open');
          }

          unlockScrollIfNothingOpen();
        }
      });
    });

    /* ----------------------------------------------------------
       Cart Drawer
       ---------------------------------------------------------- */

    var cartDrawer = document.getElementById('cart-drawer');

    function openCart() {
      if (!cartDrawer) return;

      closeMobileMenu();
      closeAllProductDrawers();

      cartDrawer.classList.add('open');
      cartDrawer.classList.add('active');
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');

      document.body.classList.add('cart-drawer-open');
      lockScroll();
    }

    function closeCart() {
      if (!cartDrawer) return;

      cartDrawer.classList.remove('open');
      cartDrawer.classList.remove('active');
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('cart-drawer-open');
      unlockScrollIfNothingOpen();
    }

    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openCart();
      });
    });

    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeCart();
      });
    });

    /* ----------------------------------------------------------
       Product Gallery — Thumbnail Click
       ---------------------------------------------------------- */

    var mainImg = document.getElementById('product-main-img');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.getAttribute('data-img-src');

        if (mainImg && src) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
        }

        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });

        this.classList.add('active');
      });
    });

    /* ----------------------------------------------------------
       Product Quantity Counter
       ---------------------------------------------------------- */

    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var input = this.parentElement.querySelector('.product-page__qty-input');

        if (input && parseInt(input.value, 10) > 1) {
          input.value = parseInt(input.value, 10) - 1;
        }
      });
    });

    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var input = this.parentElement.querySelector('.product-page__qty-input');

        if (input) {
          input.value = parseInt(input.value, 10) + 1;
        }
      });
    });

    /* ----------------------------------------------------------
       Email Conversion Popup
       ---------------------------------------------------------- */

    var popup = document.getElementById('email-popup');
    var popupCloses = document.querySelectorAll('[data-popup-close]');
    var popupForm = document.getElementById('popup-form');
    var POPUP_COOKIE = 'saunii_popup_dismissed';
    var popupShown = false;

    if (popup) {
      var delayMs = (parseInt(popup.getAttribute('data-popup-delay'), 10) || 10) * 1000;
      var exitIntent = popup.getAttribute('data-popup-exit-intent') === 'true';
      var dismissDays = parseInt(popup.getAttribute('data-popup-days'), 10) || 7;
      var dismissSeconds = dismissDays * 24 * 60 * 60;

      function popupDismissedRecently() {
        return document.cookie.indexOf(POPUP_COOKIE + '=1') !== -1;
      }

      function showPopup() {
        if (popupShown || popupDismissedRecently()) return;

        popup.classList.add('active');
        document.body.classList.add('popup-open');
        lockScroll();
        popupShown = true;
      }

      function dismissPopup() {
        popup.classList.remove('active');
        document.body.classList.remove('popup-open');
        document.cookie = POPUP_COOKIE + '=1;path=/;max-age=' + dismissSeconds;
        unlockScrollIfNothingOpen();
      }

      setTimeout(showPopup, delayMs);

      if (exitIntent) {
        document.addEventListener('mouseout', function (e) {
          if (!e.toElement && !e.relatedTarget && e.clientY < 10) {
            showPopup();
          }
        });
      }

      popupCloses.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          dismissPopup();
        });
      });

      if (popupForm) {
        popupForm.addEventListener('submit', function (e) {
          e.preventDefault();

          try {
            var emailField = popupForm.querySelector('input[name="email"]');
            var email = emailField ? emailField.value.trim() : '';

            if (email) {
              var body = new URLSearchParams();

              body.append('form_type', 'customer');
              body.append('utf8', '\u2713');
              body.append('contact[email]', email);
              body.append('contact[accepts_marketing]', 'true');
              body.append('contact[tags]', 'popup,newsletter');

              fetch('/contact#contact_form', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Accept': 'application/json'
                },
                body: body.toString()
              }).catch(function (err) {
                console.warn('[Saunii] popup submit failed:', err);
              });
            }
          } catch (err) {
            console.warn('[Saunii] popup submit error:', err);
          }

          popupForm.style.display = 'none';

          var success = document.getElementById('popup-success');

          if (success) {
            success.style.display = 'block';
          }

          setTimeout(dismissPopup, 2500);
        });
      }
    }

    /* ----------------------------------------------------------
       ESC closes overlays/drawers
       ---------------------------------------------------------- */

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMobileMenu();
        closeCart();
        closeAllProductDrawers();

        if (popup && popup.classList.contains('active')) {
          popup.classList.remove('active');
          document.body.classList.remove('popup-open');
        }

        unlockScrollIfNothingOpen();
      }
    });
  });
})();